import { months, monthsNames } from 'views/Components/Forecast/utils/monhts';
import MonthDataField from '../../Table/MonthDataField';
import InfoField from '../../Table/InfoFiel';
import EmptyTable from '../EmptyTable';
import { formatDate } from 'views/Components/Shared/utils/formatDate';

export const monthsColumns = months.map((month) => ({
	field: month,
	headerName: monthsNames[month].toUpperCase().slice(0, 3),
	headerClassName: 'header border-bottom',
	renderCell: (params) => {
		const monthData = params.value;

		return params.value?.has_changed ? (
			<MonthDataField data={monthData} />
		) : null;
	},
	width: 60,
}));

export function getGridStyles(isEmpty) {
	return {
		'& .MuiDataGrid-main': {
			paddingBottom: '0 !important',
		},
		minHeight: isEmpty ? 200 : 60,
	};
}

export const columns = [
	{
		field: 'hidden',
		headerName: '',
		headerClassName: 'header border-bottom no-padding border-right border-left',
		cellClassName: 'no-padding',
		width: 30,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: '-',
		headerName: 'SKU',
		headerClassName: 'header border-bottom border-right border-left',
		minWidth: 60,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'modified_by',
		headerName: 'Modificado por',
		headerClassName: 'header border-bottom border-right',
		minWidth: 50,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'created_at',
		headerName: 'Fecha de modificación',
		headerClassName: 'header border-bottom border-right',
		minWidth: 50,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
		valueFormatter: (value) => {
			if (value == null) {
				return '';
			}
			return formatDate(value);
		},
	},
	{
		field: 'info',
		headerName: '',
		headerClassName: 'header border-bottom',
		renderCell: () => <InfoField />,
		width: 50,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		// align: 'center',
	},
	...monthsColumns,
];

// function Skeletons() {
// 	return (
// 		<div>
// 			<Skeleton width="100%" height="200px" />
// 		</div>
// 	);
// }

export const slots = { noRowsOverlay: EmptyTable };

export const getRowId = (row) => row?.id;

export const getRowHeight = () => 60;
